import React from "react";
import { Box, Drawer, List, ListItem, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import new250Logo from "../assets/sjlogo.png";

const Drawer1 = ({ menuItems, onClose, isOpen }) => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const filteredItems = menuItems.filter((item) => item.label !== "Logout");
  const logoutItem = menuItems.find((item) => item.label === "Logout");

  return (
    <Drawer anchor="left" open={isOpen} onClose={onClose}>
      <Box
        sx={{
          width: 250,
          padding: "20px",
          backgroundColor: "#FEDDDD",
          height: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Logo */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <Box
            component="img"
            src={new250Logo}
            alt="Logo"
            width={"35%"}
            loading="lazy"
          />
        </Box>

        {/* Menu Items */}
        <List sx={{ flexGrow: 1 }}>
          {filteredItems.map((item, index) => (
            <ListItem
              button
              key={index}
              onClick={onClose}
              sx={{
                position: "relative",
              }}
            >
              <Link
                to={item.link}
                style={{
                  textDecoration: "none",
                  padding: "5px 0",
                  ...(isActive(item.link) || isActive(`/dashboard/${item.link}`)
                    ? {
                        backgroundColor:
                          isActive(item.link) ||
                          isActive(`/dashboard/${item.link}`)
                            ? "#800001"
                            : "transparent",
                        color:
                          isActive(item.link) ||
                          isActive(`/dashboard/${item.link}`)
                            ? "#fff"
                            : "#800001",
                        fontWeight: "bold",
                        padding: "10px 15px",
                        width: 150,
                        borderRadius: "10px",
                      }
                    : {}),
                }}
              >
                {item.label}
              </Link>
            </ListItem>
          ))}
        </List>

        {/* Logout Button at Bottom */}
        {logoutItem && (
          <Box sx={{ mt: 2 }}>
            <ListItem
              button
              onClick={() => {
                // clear storage and redirect to login
                localStorage.clear();
                onClose();
                window.location.href = "/";
              }}
              sx={{
                backgroundColor: "#800001",
                color: "#fff",
                borderRadius: "10px",
              }}
            >
              <Typography
                sx={{ padding: "5px 0", textAlign: "center", width: "100%" }}
              >
                {logoutItem.label}
              </Typography>
            </ListItem>
          </Box>
        )}
      </Box>
    </Drawer>
  );
};

export default Drawer1;
